export default __webpack_public_path__ + "static/setup-and-configuration-custom-titles-85fa2dc3528d221d8550bbd4860644be.mp4";